"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageForm;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _useDeviceInfo = _interopRequireDefault(require("../../utils/useDeviceInfo"));
var _FormBottomBar = _interopRequireDefault(require("../FormBottomBar"));
var _BusySpinner = _interopRequireDefault(require("../BusySpinner"));
function PageForm(props) {
  const {
    children,
    className,
    hideEdit,
    onSave,
    style,
    ...bottomBarProps
  } = props;
  const theme = (0, _material.useTheme)();
  const {
    isMobile
  } = (0, _useDeviceInfo.default)();
  const [processing, setProcessing] = (0, _react.useState)(false);
  const handleSave = async () => {
    setProcessing(true);
    // eslint-disable-next-line @typescript-eslint/await-thenable
    await onSave(); // <-- we want all onSaves to be async
    setProcessing(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, processing && /*#__PURE__*/_react.default.createElement(_BusySpinner.default, {
    withSkrim: true
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: className,
    paddingBottom: hideEdit ? theme.spacing(4) : theme.spacing(isMobile ? 25 : 15),
    style: style
  }, children), !hideEdit && /*#__PURE__*/_react.default.createElement(_FormBottomBar.default, Object.assign({
    onSave: handleSave
  }, bottomBarProps)));
}